// eslint-disable-next-line
export const downloadFile = {
  methods: {
    downloadFile(event, api) {
      event.preventDefault();
      return new Promise((resolve, reject) => {
        this.$http
          .get(api, {
            responseType: 'blob',
            timeout: 30000,
          })
          .then((response) => {
            const blob = new Blob([response.data], {
              type: response.headers.contentType || 'application/octet-stream',
            });
            let filename = '';
            const disposition = response.headers['content-disposition'];
            if (disposition && disposition.indexOf('attachment') !== -1) {
              const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              const matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, '');
                filename = decodeURIComponent(filename);
              }
            }
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
              const url = window.URL && window.URL.createObjectURL
                ? window.URL.createObjectURL(blob)
                : window.webkitURL.createObjectURL(blob);
              const link = document.createElement('a');
              link.style.display = 'none';
              link.href = url;
              link.setAttribute('download', filename);
              if (typeof link.download === 'undefined') {
                link.setAttribute('target', '_blank');
              }
              document.body.appendChild(link);
              link.click();
              setTimeout(() => {
                link.remove();
                window.URL.revokeObjectURL(url);
              }, 200);
            }
            resolve(response);
          }).catch((error) => {
            if (error.response && error.response.status === 404) {
              this.$eventBus.$emit(
                'fileNotFound',
                {
                  message: '',
                },
              );
            } else {
              this.$eventBus.$emit(
                'error500',
                {
                  message: 'Selhalo připojení k serveru.',
                },
              );
            }
            reject(error);
          });
      });
    },
  },
};
